(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gift-card-balance-checker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gift-card-balance')) {
    customElements.define('gift-card-balance', class GiftCardBalance extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('[data-balance-form]');
        this.result = this.querySelector('[data-balance-result]');
        this.errorEl = this.querySelector('[data-balance-error]');
        this.errorText = this.querySelector('[data-balance-error-text]');
        this.originalRow = this.querySelector('[data-balance-original-row]');
        this.originalEl = this.querySelector('[data-balance-original]');
        this.currentEl = this.querySelector('[data-balance-current]');
        this.numberInput = this.querySelector('[data-balance-number]');
        this.pinInput = this.querySelector('[data-balance-pin]');
        this.submitButton = this.querySelector('[data-balance-submit]');
        this.resetButton = this.querySelector('[data-balance-reset]');
        this.endpoint = this.dataset.endpoint;
        this.currency = this.dataset.currency || 'AUD';
        this.unavailableMessage = this.dataset.unavailableMessage;
        this.lookupErrorMessage = this.dataset.errorMessage;
      }

      connectedCallback() {
        if (this.form) this.form.addEventListener('submit', this.onSubmit.bind(this));
        if (this.resetButton) this.resetButton.addEventListener('click', this.onReset.bind(this));
      }

      onSubmit(event) {
        event.preventDefault();
        this.hideError();
        const voucher = this.numberInput ? this.numberInput.value.trim() : '';
        const pin = this.pinInput ? this.pinInput.value.trim() : '';
        if (!voucher || !pin) {
          const emptyField = !voucher ? this.numberInput : this.pinInput;
          if (emptyField) emptyField.focus();
          return;
        }
        if (!this.endpoint) {
          this.showError(this.unavailableMessage);
          return;
        }
        this.setLoading(true);
        fetch(this.endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ operation: 'BALANCE', voucher: voucher, pin: pin })
        })
          .then((response) => {
            if (!response.ok) throw new Error('lookup_failed');
            return response.json();
          })
          .then((data) => {
            const balance = data && data.balance;
            if (!balance || balance.available_amount === undefined || balance.available_amount === null) {
              throw new Error('not_found');
            }
            this.showResult(balance);
          })
          .catch(() => {
            this.showError(this.lookupErrorMessage);
          })
          .then(() => {
            this.setLoading(false);
          });
      }

      showResult(balance) {
        const original = this.formatMoney(balance.original_amount);
        if (this.originalRow) this.originalRow.hidden = !original;
        if (this.originalEl) this.originalEl.textContent = original;
        if (this.currentEl) this.currentEl.textContent = this.formatMoney(balance.available_amount);
        if (this.result) this.result.hidden = false;
        if (this.submitButton) this.submitButton.hidden = true;
      }

      formatMoney(amount) {
        const value = Number(amount);
        if (Number.isNaN(value)) return '';
        try {
          return new Intl.NumberFormat(undefined, {
            style: 'currency',
            currency: this.currency,
            currencyDisplay: 'narrowSymbol'
          }).format(value);
        } catch (error) {
          return new Intl.NumberFormat(undefined, { style: 'currency', currency: this.currency }).format(value);
        }
      }

      onReset(event) {
        event.preventDefault();
        if (this.numberInput) this.numberInput.value = '';
        if (this.pinInput) this.pinInput.value = '';
        this.hideError();
        if (this.result) this.result.hidden = true;
        if (this.submitButton) this.submitButton.hidden = false;
        if (this.numberInput) this.numberInput.focus();
      }

      setLoading(isLoading) {
        if (!this.submitButton) return;
        this.submitButton.classList.toggle('is-loading', isLoading);
        this.submitButton.disabled = isLoading;
      }

      showError(message) {
        if (!this.errorEl) return;
        if (this.errorText) this.errorText.textContent = message;
        this.errorEl.hidden = false;
      }

      hideError() {
        if (!this.errorEl) return;
        this.errorEl.hidden = true;
        if (this.errorText) this.errorText.textContent = '';
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
